module.exports = __webpack_public_path__ + "catalog/holes/sliding-door/slidingDoor.png";